<script setup>
import BaseText from "@/library/BaseText.vue";
</script>

<template>
  <BaseText
    as="h1"
    variant="headline-3-bold"
  >
    <slot />
  </BaseText>
</template>
